<template lang="html">
  <el-cascader filterable placeholder="请选择" expand-trigger="hover" @change="handleChange" v-model="pointerId" :props="prop" :options="treeList" style="width:400px;">
  </el-cascader>
</template>
<script>
import account from '../../data/basic/plan/company.js'
export default {
  data() {
    return {
      prop: {
        value: 'code',
        label: 'name',
        children: 'children'
      },
      treeList: [],
      pointerId: [],
      pointerName: [],

    };
  },
  props: ['defaultData'],

  created() {
    this.getTree()
    this.pointerId = this.defaultData
  },

  methods: {
    getTree() {
      account.get_tree().then(resolve => {
        // console.log(resolve, 11)
        this.formatTree(resolve)
      })
    },
    // 格式化数据
    formatTree(val) {
      // if (!val[0].children) return;
      let dataList = []
      let formatData = function(data) {
        for (let i = 0; i < data.length; i++) {
          let m = dataList[i] = {}
          let n = data[i].children
          m.name = data[i].name
          m.code = data[i].code
          if (n.length > 0) {
            m.children = []
            for (let j = 0; j < n.length; j++) {
              let o = (m.children)[j] = {}
              let p = n[j].children
              o.name = n[j].name
              o.code = n[j].code
              if (p.length > 0) {
                o.children = []
                for (let k = 0; k < p.length; k++) {
                  let q = (o.children)[k] = {}
                  let r = p[k].children
                  q.name = p[k].name
                  q.code = p[k].code
                }
              }
            }
          }
        }
      }
      formatData(val)
      this.treeList = dataList
    },
    handleChange() {
      this.$emit('change', this.pointerId)
      // this.$emit('transmitName', this.pointerName)
    }
  }
}

</script>
<style lang="css" scoped>


</style>



// WEBPACK FOOTER //
// Datatree.vue?d2388c9e